import { useState } from "react";
import { Categories } from "@/components/Categories";
import { Spotlight } from "@/components/Spotlight";
import { Quotes } from "@/components/Quotes";
import { DesignStudio } from "@/components/DesignStudio";

export default function DraftPage() {
  const [studioOpen, setStudioOpen] = useState(false);

  return (
    <main data-testid="draft-page" className="bg-[#EFE8DC] text-[#2C241E] overflow-x-clip">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8 flex items-center justify-between gap-4">
        <a
          href="/"
          data-testid="draft-back-link"
          className="text-xs md:text-sm font-medium tracking-[0.35em] uppercase text-[#2C241E]"
        >
          LIGATEN
        </a>
        <span className="text-[10px] font-medium tracking-[0.25em] uppercase text-[#2C241E]/40">
          Draft — Phase 2 Preview
        </span>
        <button
          data-testid="draft-design-yours-button"
          onClick={() => setStudioOpen(true)}
          className="text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
        >
          Design Yours
        </button>
      </div>
      <div className="pt-16 md:pt-24">
        <Categories />
      </div>
      <Spotlight />
      <Quotes />
      {studioOpen && (
        <DesignStudio onClose={() => setStudioOpen(false)} onJoin={() => setStudioOpen(false)} />
      )}
    </main>
  );
}
